export default __webpack_public_path__ + "static/media/Inter-VariableFont.aadb65ac.ttf";